import TherapyResponse from "../models/serviceApi/TherapyResponse";
import Therapy from "../models/domain/Therapy";

export default class TherapyMapper {
  static mapResponseToModel(response: TherapyResponse): Therapy {
    return new Therapy(
      response.id,
      response.name,
      response.type,
      response.duration,
      response.durationUnit,
    );
  }

  static mapResponseArrayToModel(responses: TherapyResponse[]): Therapy[] {
    return responses.map(this.mapResponseToModel);
  }
}
